import React from "react";
import { Home, Search } from "lucide-react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="mx-auto max-w-2xl rounded-3xl border border-white/10 bg-white/5 p-8 text-center md:p-12" aria-labelledby="not-found-title">
      <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#ff8b94]">Page not found</p>
      <h1 id="not-found-title" className="mt-3 text-3xl font-black md:text-5xl">We couldn’t find that page</h1>
      <p className="mx-auto mt-4 max-w-xl leading-7 text-white/70">
        The address may be out of date, or the page may have moved. Use one of the links below to continue.
      </p>
      <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
        <Link className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl bg-[#E63946] px-5 py-3 font-bold text-white" to="/">
          <Home className="h-5 w-5" aria-hidden="true" /> Return home
        </Link>
        <Link className="inline-flex min-h-12 items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/10 px-5 py-3 font-bold text-white" to="/directory">
          <Search className="h-5 w-5" aria-hidden="true" /> Find local support
        </Link>
      </div>
    </section>
  );
}
